import * as React from "react";
import AppContext from "../AppContext";

export const useFullHeight = () => {
  const context = React.useContext(AppContext);
  React.useEffect(() => {
    context.setFullHeight(true);
    return function cleanup() {
      context.setFullHeight(false);
    };
  }, []);
}